import { createFileRoute, Link } from "@tanstack/react-router";
import { PlusIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useTeacherClassesGetTeacherClassDetail } from "@/orval/teacher-classes";
import { TeacherClassUpdateTable } from "./-components/teacher-class-update-table";

export const Route = createFileRoute("/_app/organizations/$organizationId/teacher/classes_/$classId/updates/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationId, classId } = Route.useParams();
  const { isLoading } = useTeacherClassesGetTeacherClassDetail(organizationId, classId);

  return (
    <>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <div>
          <h2 className="text-xl font-semibold tracking-tight text-foreground">Updates</h2>
          <p className="text-sm text-muted-foreground">Create drafts, publish updates, and manage attachments.</p>
        </div>
        <Button asChild size="sm">
          <Link
            to="/organizations/$organizationId/teacher/classes/$classId/updates/new"
            params={{ organizationId, classId }}
          >
            <PlusIcon className="mr-2 size-4" />
            New Update
          </Link>
        </Button>
      </div>

      {isLoading ? (
        <Skeleton className="h-32 w-full" />
      ) : (
        <TeacherClassUpdateTable organizationId={organizationId} classId={classId} />
      )}
    </>
  );
}
